import { Component, OnInit, ViewChild } from '@angular/core';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDisclaimerGroupComponent, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { RomaneioService } from '../service/romaneio.service';
import { Router } from '@angular/router';
import { PoStorageService } from '@po-ui/ng-storage';
import { ExcelService } from 'src/app/service/excel-service';
import { FiltroRelatorioBaldeio } from '../filter/filtro-relatorio-baldeio';
import { RelatorioBaldeioItem } from '../interface/romaneio';

@Component({
  selector: 'app-relatorio-baldeio',
  templateUrl: './relatorio-baldeio.component.html',
  styleUrls: ['./relatorio-baldeio.component.css']
})
export class RelatorioBaldeioComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroRelatorioBaldeio;

  varOrigem: Array<PoSelectOption>;
  varStatusBA: Array<PoSelectOption>;
  varStatusCL: Array<PoSelectOption>;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  inputPesquisar: string = '';
  tabelaPrincipalFiltrados: Array<any> = [];
  tabelaPrincipalOriginal: Array<any> = [];

  

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private poStorageService: PoStorageService,
    private excelService: ExcelService,
    private poNotificationService: PoNotificationService,
    private poDialogService: PoDialogService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroRelatorioBaldeio(this.poStorageService);

    this.varOrigem = this.listaOrigem();
    this.varStatusBA = this.listaStatusBaldeio();
    this.varStatusCL = this.listaStatusCliente();
  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;

  ngOnInit(): void {
    this.tabelaPrincipalLoad();
  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

this.romaneioService.listaRelatorioBaldeio(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {

  const dados = lista.items.map(item => ({
    ...item,
    DURACAO: this.calcularDuracao(
      item.DZ00DATA,
      item.CZ00HORA,
      item.DZ00DTFIM,
      item.CZ00HRFIM
    ),
    DURACAO2: this.calcularDuracao(
      item.DZ00DATABX,
      item.CZ00HORABX,
      item.DZ00DTFIM,
      item.CZ00HRFIM
    )
  }));

  this.tabelaPrincipalItens = dados;
  this.tabelaPrincipalFiltrados = dados;
  this.tabelaPrincipalOriginal = dados;

});
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CZ00COD'   , label: 'Romaneio'        , width: '7%'},
    {property: 'CZ00DESTIN', label: 'Destino'         , width: '10%', type: 'label',
      labels: [
        { value: 'SO', color: 'color-01',  label: 'DANOS SOLIDA'    },
        { value: 'BA', color: 'color-05',  label: 'CD SOLIDA' },
        { value: 'CL', color: 'color-08',  label: 'CLIENTE' },
      ]
    },
    {property: 'CZ00STATUS', label: 'Status'          , width: '13%', type: 'label',
      labels: [
        { value: 'A', color: 'color-08',  label: 'Pend. Confirmação'  },
        { value: '0', color: 'color-01',  label: 'Pend. Envio'        },
        { value: '1', color: 'color-05',  label: 'Pend. Recebimento'  },
        { value: 'Z', color: 'color-12',  label: 'Recebido'           },
        { value: 'CL0', color: 'color-01',  label: 'Expedição'        },
        { value: 'CL1', color: 'color-05',  label: 'Comercial'        },
        { value: 'CL2', color: 'color-08',  label: 'A Faturar'        },
        { value: 'CL3', color: 'color-12',  label: 'Fat. Sem Dados'   },
        { value: 'CLZ', color: 'color-03',  label: 'Finalizado'       },
      ]
    },
    {property: 'DZ00DATA'   , label: 'Dt. Criação'    , width: '7%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'DZ00DTFIM'  , label: 'Dt. Fim'        , width: '7%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ00PLACA'  , label: 'Placa'          , width: '7%'},
    {property: 'CZ00COTNER' , label: 'Container'      , width: '7%'},
    {property: 'CZ00PROCES' , label: 'Processo'       , width: '7%'},
    {property: 'CZ00CAMICP' , label: 'Transportadora' , width: '7%'},
    {property: 'CZ00SELOD'  , label: 'Selo Def.'      , width: '7%'},
    {property: 'CZ00SELOP'  , label: 'Selo Prov.'     , width: '7%'},
    {property: 'CZ00CLIENT' , label: 'Cliente'        , width: '7%'},
    {property: 'CZ00NOTA'   , label: 'Nota'           , width: '7%'},
    {property: 'DURACAO'    , label: 'Duração'        , width: '7%'},
    
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', action: this.goHome.bind(this) },
      { label: 'Relatório Baldeio' }
    ]
  };


  gerarExcel(): void {
    const lista_excel = this.tabelaPrincipalOriginal.map( (item) => {
      return{
        'Cód. Romaneio'           : item.CZ00COD,
        'Destino'                 : item.CZ00DESTIN == 'CL' ? 'Cliente' : item.CZ00DESTIN == 'BA' ? 'Baldeio' : 'DANOS SOLIDA',
        'Status'                  : this.getStatusRomaneio(item.CZ00STATUS),
        'Dt. Inicial Carreg.'     : this.formatarData(item.DZ00DATA),
        'Hr. Inicial Carreg.'     : item.CZ00HORA,
        'Dt. Inicial Descarreg.'  : this.formatarData(item.DZ00DATABX),
        'Hr. Inicial Descarreg.'  : item.CZ00HORABX,
        'Dt. Final Descarreg.'    : this.formatarData(item.DZ00DTFIM),
        'Hr. Final Descarreg.'    : item.CZ00HRFIM,
        'Placa'                   : item.CZ00PLACA,       
        'Tempo Total de Baldeio'  : item.DURACAO, 
        'Tempo de Descarga'       : item.DURACAO2, 
      }
      
    });

    this.excelService.exportAsExcelFile(lista_excel, `Relatório Baldeio`);
  }

  changeFiltro(filtro: string): void {
    if(filtro.trim()){
      this.tabelaPrincipalFiltrados = this.tabelaPrincipalOriginal.filter(({CZ00COD, CZ00PLACA, CZ00COTNER, CZ00PROCES, CZ00CAMICP, CZ00SELOD, CZ00SELOP, CZ00CLIENT, CZ00NOTA}) =>
        CZ00COD.startsWith(filtro) || CZ00PLACA.startsWith(filtro) || CZ00COTNER.startsWith(filtro) || CZ00PROCES.startsWith(filtro) || CZ00CAMICP.startsWith(filtro) || CZ00SELOD.startsWith(filtro) || CZ00SELOP.startsWith(filtro) || CZ00CLIENT.startsWith(filtro) || CZ00NOTA.startsWith(filtro)
      )
    } else {
      this.tabelaPrincipalFiltrados = this.tabelaPrincipalOriginal
    }

    this.tabelaPrincipalItens = this.tabelaPrincipalFiltrados
  }

  bttnPDF(): void {

    let arrayRomaneios: Array<any> = [];

    if(this.tabelaPrincipalItens.length > 0){
      this.poDialogService.confirm({
        title: "Baixar PDF's",
        message: 'Essa ação irá fazer o download do PDF de TODOS os registros listados em tela. Confirmar operação?',
        confirm: () =>{
          this.tabelaPrincipalItens.forEach((item) => {
            arrayRomaneios.push(item.CZ00COD)
          });

          this.downloadPDF(arrayRomaneios)
        }
      })
    } else {
      this.poNotificationService.warning("Sem registros em tela para gerar PDF.")
    }
  }

  downloadPDF(Romaneios: Array<any>): void {
    Romaneios.forEach((item) => {
      this.romaneioService.getPdfRomaneio(item).subscribe((ret) => {
        var file = new Blob([ret], {type: 'application/pdf'});
        var fileName = `ROMANEIO_${item}_${new Date().toLocaleString()}.pdf`;
        var a = document.createElement("a");
        document.body.appendChild(a);

        var fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
      })
    })
  }

  listaOrigem(): Array<PoSelectOption> {
    return [
        { value: "SO", label: "Solida"    },
        { value: "BA", label: "CD Solida" },
    ];
  }

  listaStatusCliente(): Array<PoSelectOption> {
    return [
      { value: "T", label: "Todos" },
      { value: "N", label: "Nenhum" },
      { value: "0", label: "Disp. Romaneio" },
      { value: "1", label: "Lib. Comercial" },
      { value: "2", label: "Pendente NFs" },
      { value: "3", label: "Fat. sem Dados" },
      { value: "4", label: "A Carregar" },
      { value: "5", label: "Carregamento Autorizado" },
      { value: "6", label: "Carregado" },
      { value: "Z", label: "Finalizado" },
    ];
  }

  listaStatusBaldeio(): Array<PoSelectOption> {
    return [
      { value: "T", label: "Todos"                },
      { value: "N", label: "Nenhum"               },
      { value: "A", label: "Pendente Confirmação" },
      { value: "0", label: "Pendente Envio"       },
      { value: "1", label: "Pendente Recebimento" },
      { value: "Z", label: "Recebido"             },
    ];
  }

  getStatusRomaneio(cStatus: string) {
    if (cStatus == 'A') {
      return 'Pend. Confirmação';
    } else if (cStatus == '0') {
      return 'Pend. Envio';
    } else if (cStatus == '1') {
      return 'Pend. Recebimento';
    } else if (cStatus == 'Z') {
      return 'Recebido';
    } else if (cStatus == 'CL0') {
      return 'Expedição';
    } else if (cStatus == 'CL1') {
      return 'Comercial';
    } else if (cStatus == 'CL2') {
      return 'A Faturar';
    } else if (cStatus == 'CL3') {
      return 'Fat. Sem Dados';
    } else {
      return 'Finalizado';
    }
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

  calcularDuracao(
  dtIni: Date | string | undefined,
  hrIni: string,
  dtFim: Date | string | undefined,
  hrFim: string
): string {
  

  if (!dtIni || !hrIni || !dtFim || !hrFim) {
    return '';
  }
  
  

  const dataIni = dtIni ? (typeof dtIni === 'string' ? new Date(dtIni) : dtIni) : null;
  const dataFim = dtFim ? (typeof dtFim === 'string' ? new Date(dtFim) : dtFim) : null;

  if (!dataIni || !dataFim) return '';

  const dataHoraIni = new Date(
    `${dataIni.getFullYear()}-${this.pad(dataIni.getMonth() + 1)}-${this.pad(dataIni.getDate())}T${hrIni}`
  );

  const dataHoraFim = new Date(
    `${dataFim.getFullYear()}-${this.pad(dataFim.getMonth() + 1)}-${this.pad(dataFim.getDate())}T${hrFim}`
  );

  const diffMs = dataHoraFim.getTime() - dataHoraIni.getTime();

  if (diffMs < 0) return '';

  const totalSegundos = Math.floor(diffMs / 1000);

  const horas = Math.floor(totalSegundos / 3600);
  const minutos = Math.floor((totalSegundos % 3600) / 60);
  const segundos = totalSegundos % 60;

  return `${this.pad(horas)}:${this.pad(minutos)}:${this.pad(segundos)}`;
}
  pad(valor: number): string {
  return valor.toString().padStart(2, '0');
  }

  formatarData(data: any): string {
  if (!data) return '';

  const d = new Date(data);

  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const ano = d.getFullYear();

  return `${dia}/${mes}/${ano}`;
}
}
